import React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import Map from '../views/map'

export const Route = createFileRoute('/')({
  component: RouteComponent,
})

export default function RouteComponent() {
  const search = Route.useSearch() as { mode?: string; v?: string; k?: string };
  return <Map search={search} />;
}
